import styled from 'styled-components';

export const FilterBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.sm};
`;

export const FilterControlsRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    width: 100%;
  }
`;

export const FilterTriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.xs};
  height: 36px;
  padding: 0 ${({ theme }) => theme.landingSpacing.md};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: 1px solid
    ${({ theme, $active }) => ($active ? theme.landing.buttonBg : theme.landing.cardBorder)};
  background: ${({ theme }) => theme.landing.cardBg};
  color: ${({ theme }) => theme.landing.text};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    transform 0.1s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    flex: 1;
    justify-content: center;
  }
`;

export const FilterCountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: ${({ theme }) => theme.landingBorderRadius.full};
  background: ${({ theme }) => theme.landing.buttonBg};
  color: #ffffff;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 10px;
  font-weight: 700;
`;

/* ---------- Dropdown ---------- */

export const FilterDropdown = styled.div`
  position: absolute;
  top: calc(100% + ${({ theme }) => theme.landingSpacing.xs});
  right: 0;
  z-index: 30;
  width: 320px;
  max-width: calc(100vw - ${({ theme }) => theme.landingSpacing.md} * 2);
  padding: ${({ theme }) => theme.landingSpacing.md};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  background: ${({ theme }) => theme.landing.cardBg};
  /* No dedicated elevation token in theme — a fixed-opacity shadow reads
     fine on both light and dark cardBg, so it isn't theme-driven. */
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    right: 0;
    left: 0;
    width: auto;
    max-width: none;
  }
`;

export const FilterDropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.landingSpacing.sm};
`;

export const FilterDropdownTitle = styled.strong`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
  font-weight: 700;
  color: ${({ theme }) => theme.landing.text};
`;

export const FilterDropdownClose = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.landing.textMuted};
  cursor: pointer;

  svg {
    width: 13px;
    height: 13px;
  }

  &:hover {
    color: ${({ theme }) => theme.landing.text};
  }
`;

export const FilterSection = styled.div`
  margin-bottom: ${({ theme }) => theme.landingSpacing.sm};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const FilterSectionLabel = styled.label`
  display: block;
  margin-bottom: ${({ theme }) => theme.landingSpacing.xs};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.landing.text};
`;

export const FilterSelect = styled.select`
  width: 100%;
  height: 36px;
  padding: 0 32px 0 ${({ theme }) => theme.landingSpacing.sm};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  background: ${({ theme }) => theme.landing.cardBg}
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2394a3b8' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m19.5 8.25-7.5 7.5-7.5-7.5' /%3E%3C/svg%3E")
    no-repeat right 10px center / 16px 16px;
  color: ${({ theme }) => theme.landing.text};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
  appearance: none;
  cursor: pointer;

  &:focus-visible {
    outline: none;
    border-color: ${({ theme }) => theme.landing.buttonBg};
  }
`;

export const FilterDropdownFooter = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.xs};
  margin-top: ${({ theme }) => theme.landingSpacing.sm};
  padding-top: ${({ theme }) => theme.landingSpacing.sm};
  border-top: 1px solid ${({ theme }) => theme.landing.cardBorder};
`;

export const ClearFilterButton = styled.button`
  flex: 1;
  height: 36px;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  background: ${({ theme }) => theme.landing.cardBg};
  color: ${({ theme }) => theme.landing.text};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
  }
`;

export const ApplyFilterButton = styled.button`
  flex: 1;
  height: 36px;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: none;
  background: ${({ theme }) => theme.landing.buttonBg};
  color: #ffffff;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }
`;

/* ---------- Active filter chips ---------- */

export const ActiveFiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.xs};
  padding-top: ${({ theme }) => theme.landingSpacing.xs};
  border-top: 1px solid ${({ theme }) => theme.landing.cardBorder};
`;

export const ActiveFiltersLabel = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.landing.textMuted};
`;

export const FilterTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px ${({ theme }) => theme.landingSpacing.sm};
  border-radius: ${({ theme }) => theme.landingBorderRadius.full};
  background: ${({ theme }) => theme.landing.iconBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  color: ${({ theme }) => theme.landing.text};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.small};
`;

export const FilterTagValue = styled.span`
  font-weight: 600;
`;

export const RemoveFilterButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.landing.textMuted};
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
  }

  &:hover {
    color: ${({ theme }) => theme.landing.text};
  }
`;

export const ResetAllButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  margin-left: ${({ theme }) => theme.landingSpacing.xs};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: 500;
  color: ${({ theme }) => theme.landing.linkColor};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.landing.linkHover};
    text-decoration: underline;
  }
`;
export const DateRangeRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.xs};
`;

export const DateInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 36px;
  padding: 0 ${({ theme }) => theme.landingSpacing.sm};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  background: ${({ theme }) => theme.landing.cardBg};
  color: ${({ theme }) => theme.landing.text};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
  cursor: pointer;

  /* Match the light/dark calendar-icon glyph to theme text color where supported */
  &::-webkit-calendar-picker-indicator {
    filter: ${({ theme }) => (theme.isDark ? 'invert(1)' : 'none')};
    cursor: pointer;
  }

  &:focus-visible {
    outline: none;
    border-color: ${({ theme }) => theme.landing.buttonBg};
  }
`;

export const DateRangeSeparator = styled.span`
  color: ${({ theme }) => theme.landing.textMuted};
  font-size: ${({ theme }) => theme.fontSizes.small};
`;
